import * as superagent from 'superagent';

export function logToken(token: string) {
  return new Promise((resolve, reject) => {
    const url = '/ajax/log_token/';

    superagent
      .post(url)
      .type('form')
      .send({ token })
      .end((err, res) => {
        if (err) {
          reject(err);
          return;
        }

        if (res.body && res.body.status && res.body.status.toLowerCase() === 'ok') {
          resolve();
          return;
        }

        reject(new Error(`Unexpected Network Error: ${res.status}`));
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/log_token.ts